/* eslint-disable */
function L(Y) {
    const Z = /[\\\"<>\.;]/;
    const X = Z.exec(Y) != null;
    return X && window.encodeURIComponent ? encodeURIComponent(Y) : Y;
}
export default {
    // ��ȡ��ַqueryString
    getQueryString(name) {
        const search = window.location.search || window.location.hash || '';
        const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
        const r = search.split('?')[1] ? search.split('?')[1].match(reg) : null;
        if (r != null) {
            return r[2];
        }
        return null;
    }
};
